import { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import {
  selectJustInCollection,
  selectSpecialCollection,
} from "../../redux/shop/shop.selectors";

import useStyles from "./nav-bar.styles";

import ShopByPetMenu from "../shop-by-pet-menu";
import ShopByBrandMenu from "../shop-by-brand-menu";

const NavBar = () => {
  const justInCollection = useSelector(selectJustInCollection);
  const specialCollection = useSelector(selectSpecialCollection);

  const [shopByPetOpen, setShopByPetOpen] = useState(false);
  const [shopByBrandOpen, setShopByBrandOpen] = useState(false);

  const matches = useMediaQuery("(min-width:1200px)");

  const classes = useStyles({
    matches,
  });

  return (
    <div className={classes.container}>
      <div className={classes.linkContainer}>
        <Link to={`/shop?collectionId=${justInCollection.collectionId}`}>
          Just In
        </Link>
      </div>
      <div
        className={`${classes.linkContainer} ${classes.menuContainer}`}
        onMouseEnter={() => setShopByPetOpen(true)}
        onMouseLeave={() => setShopByPetOpen(false)}
      >
        <Link to="/">Shop by Pet</Link>
        <ShopByPetMenu open={shopByPetOpen} setOpen={setShopByPetOpen} />
      </div>
      <div
        className={`${classes.linkContainer} ${classes.menuContainer}`}
        onMouseEnter={() => setShopByBrandOpen(true)}
        onMouseLeave={() => setShopByBrandOpen(false)}
      >
        <Link to="/">Shop by Brand</Link>
        <ShopByBrandMenu open={shopByBrandOpen} setOpen={setShopByBrandOpen} />
      </div>
      <div className={classes.linkContainer}>
        <Link to={`/shop?collectionId=${specialCollection.collectionId}`}>
          Special
        </Link>
      </div>
      <div className={classes.linkContainer}>
        <Link to="/">Pet Service</Link>
      </div>
    </div>
  );
};

export default NavBar;
